import { Download, X } from 'lucide-react';
import { useInstallPrompt } from '@/lib/pwa';

export function InstallPrompt() {
  const { canPrompt, promptInstall, dismiss } = useInstallPrompt();

  if (!canPrompt) return null;

  return (
    <div
      role="dialog"
      aria-label="Install TownInsider"
      className="fixed inset-x-3 bottom-3 z-30 mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-cream-100 px-4 py-3 text-sm text-moor-800 shadow-lg ring-1 ring-moor-200/60 safe-bottom animate-slide-up"
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-moor-700 text-white">
        <Download className="h-5 w-5" aria-hidden="true" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-medium leading-tight">Install TownInsider</p>
        <p className="mt-0.5 text-xs text-moor-700">Add it to your home screen.</p>
      </div>
      <button
        type="button"
        onClick={() => {
          void promptInstall();
        }}
        className="rounded-full bg-moor-700 px-3 py-1.5 text-xs font-medium text-white transition hover:bg-moor-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-moor-500 focus-visible:ring-offset-2"
      >
        Install
      </button>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss install prompt"
        className="rounded-full p-1 text-moor-600 transition hover:bg-moor-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-moor-500 focus-visible:ring-offset-2"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
